import { getColumnDataType } from "./getColumnDataType";

/**
 * Determines the data type of a column for filtering purposes
 * @param {Object} column - The column object
 * @param {Array} rows - Table data rows
 * @param {Object} formCondition - Current filter condition object
 * @param {Function} updateFormData - Function to update form data (optional)
 * @returns {String} The determined data type
 */
export const determineColumnDataType = (
  column,
  rows,
  formCondition,
  updateFormData
) => {
  // Check if column has predefined dataType, otherwise determine it
  const dataType = column.dataType || getColumnDataType(column, rows);

  // Update the form condition if needed
  if (!formCondition.dataType || formCondition.dataType !== dataType) {
    formCondition.dataType = dataType;
    formCondition.operator = ""; // Reset operator when data type changes
    if (updateFormData) {
      updateFormData();
    }
  }

  return dataType;
};

export default determineColumnDataType;